export default function internationalEventList() {
  return {
    eventList: [],
    tempNewsList: [],
    totalCount: 0,
    pageCount: 0,
    currentPage: 1,
    hasMore: false,
    currentPageURLPart: "",

    
    next() {
      this.currentPage = this.currentPage + 1;
        this.bindInternationalEventsList();
    },
    bindInternationalEventsList() {
        var path = document.getElementById("hdnInternationalEventPageUrl").value;
        path = path != "" ? document.getElementById("hdnInternationalEventPageUrl").value : "/International-Programs/International-Events";
      var pageSize = document.getElementById("DefaultNoOfRows").value * 3;

      fetch(
        "/api/InternationalEventsAPI/GetEvents?treeNode=" +
          path +
          "&pageSize=" +
          pageSize +
          "&pageNumber=" +
          this.currentPage,
        { method: "GET" }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .then((response) => {
          Array.prototype.push.apply(this.eventList, response.eventList);
          this.hasMore = response.hasMore;
        });
    },
    init() {
        this.bindInternationalEventsList();
    },
  };
}
